import TaskObj from 'model/taskObj'
import "./window.css"
import React, { useContext, useEffect, useRef, useState } from 'react'
import { desktopAppTaskContex } from '.';
import { faChevronCircleUp, faPlusCircle, faTimesCircle, faStopCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Window(props: { task: TaskObj }) {
    const TASKBAR = 40;
    const AUTO_RATIO = 0.7;
    const screenW = document.documentElement.clientWidth;
    const screenH = document.documentElement.clientHeight;
    const workH = screenH - TASKBAR;
    const def = props.task.app.config.req.defSize;
    const auto = def === 'AUTO';
    const defaultMinWindowSizeH = props.task.app.config.req.minSize.height || 300;
    const defaultMinWindowSizeW = props.task.app.config.req.minSize.width || 460;
    const defaultWindowSizeW = Math.max(
        defaultMinWindowSizeW,
        auto ? Math.round(screenW * AUTO_RATIO) : Math.min(screenW - 5, def.width) || 460
    );
    const defaultWindowSizeH = Math.max(
        defaultMinWindowSizeH,
        auto ? Math.round(workH * AUTO_RATIO) : Math.min(screenH, def.height - 10) || 300
    );
    const defaultPositionX = Math.round((screenW - defaultWindowSizeW) / 2);
    const defaultPositionY = Math.max(
        TASKBAR,
        Math.round(TASKBAR + (workH - defaultWindowSizeH) / 2 - 15)
    );


    const [desktopControll] = useContext(desktopAppTaskContex);
    const [tilingVisual, setTilingVisual] = useState<false | 'L' | 'R' | 'F'>(false);
    const windowRef = useRef<HTMLDivElement | null>(null);
    const [windowSizeH, setWindowSizeH] = useState<number>(defaultWindowSizeH);
    const [windowSizeW, setWindowSizeW] = useState<number>(defaultWindowSizeW);
    const [minWindowSizeH, setMinWindowSizeH] = useState<number>(defaultMinWindowSizeH);
    const [minWindowSizeW, setMinWindowSizeW] = useState<number>(defaultMinWindowSizeW);
    const [positionX, setPositionX] = useState<number>(defaultPositionX);
    const [positionY, setPositionY] = useState<number>(defaultPositionY);
    const [isOnDrag, setIsOnDrag] = useState<boolean>(false);
    const [tiling, setTiling] = useState<boolean | 'F' | 'L' | 'R'>(
        props.task.app.config.defaultFullScreen ? 'F' : false
    );
    const [onSmallScreen, setOnSmallScreen] = useState<boolean>(false)

    const AppBody = props.task.app.body

    useEffect(() => {
        rePositionWindow()
        //forceUpdateDisplay()
        const thisAppWindow = windowRef.current; //find the windows just created
        if (thisAppWindow) {
            props.task.setTaskWindowsRef(thisAppWindow); //put it inside the object.
        }

        setTimeout(() => { fixInitPositionOverlap() }, 100);
        return () => {

        };
    }, []);

    useEffect(() => {
        if (desktopControll.screenSize.screenWidth < 768) {
            setOnSmallScreen(true)
        } else {
            setOnSmallScreen(false)
        }
        rePositionWindow()
    }, [desktopControll.screenSize.screenWidth, desktopControll.screenSize.screenWidth]);







    const toggleFullScreen = () => {
        desktopControll.focusTask(props.task.taskID)
        setTiling(pre => (pre === 'F' ? false : 'F'))
    }

    const setMinisized = () => {
        desktopControll.minisizedTask(props.task.taskID)
    }




    const fixInitPositionOverlap = () => {
        let currY = positionY;
        let currX = positionX;
        desktopControll.taskList.forEach((task: TaskObj) => {
            if (task.taskWindowRef && task.taskID !== props.task.taskID) {
                if ((task.taskWindowRef.offsetTop > currY - 2) && (task.taskWindowRef.offsetTop < currY + 2)) {
                    currY += 40
                }
                if ((task.taskWindowRef.offsetLeft > currX - 2) && (task.taskWindowRef.offsetLeft < currX + 2)) {
                    currX += 40
                }
            }
        })
        setPositionX(currX)
        setPositionY(currY)
    }

    const rePositionWindow = (e?: any) => {

        //Window Tilding checking
        if (e && isOnDrag && !e.target.classList.contains('resizer')) {
            if (e.pageY < 30 && e.pageY > 0) {
                setTiling('F')
            }
            if (e.pageX >= -20 && e.pageX < 10) {
                setTiling('L')
            }
            if (e.pageX >= (document.documentElement.clientWidth - 10) && e.pageX < document.documentElement.clientWidth + 20) {
                setTiling('R')
            }
            setTimeout(() => {
                //focusTask(props.task.taskID)
            }, 100);
        }
        //Window position fix (overflow)
        if (positionX + (windowSizeW / 2) > desktopControll.screenSize.screenWidth) {
            setPositionX(document.documentElement.clientWidth - windowSizeW)
        }
        if (positionX < -Math.abs((windowSizeW / 2))) {
            setPositionX(1)
        }
        if (positionY + (windowSizeH / 2) > desktopControll.screenSize.screenHeight) {
            setPositionY(document.documentElement.clientHeight - windowSizeH)
        }
        if (positionY < 40) {
            setPositionY(40)
        }

    }

    const onMouseDown = (event: any, action: string) => {
        event.preventDefault();

        //this.handleChangeAS(this.props.appINFO.name, 'changeFoucs')
        desktopControll.focusTask(props.task.taskID)
        var desktopElement = document.getElementById('desktop');
        var target = event.target;
        let original_width = windowSizeW;
        let original_height = windowSizeH;
        let original_x = positionX;
        let original_y = positionY;
        let original_mouse_x = event.pageX;
        let original_mouse_y = event.pageY;

        if (action === 'dragMove' && !onSmallScreen) {
            if (desktopElement) { desktopElement.style.cursor = 'move'; }
            if (tiling) {
                original_x = event.pageX - (windowSizeW / 2);
                original_y = event.pageY - 10;
            }
            document.onmousemove = (event) => {
                if (event.pageY < 30) {
                    setTilingVisual('F')
                }
                else if (event.pageX >= -20 && event.pageX < 10) {
                    setTilingVisual('L')
                }
                else if (event.pageX >= (document.documentElement.clientWidth - 10) && event.pageX < document.documentElement.clientWidth + 20) {
                    setTilingVisual('R')
                } else {
                    setTilingVisual(false)
                }
                setTiling(false)
                setIsOnDrag(true)
                setPositionX(original_x + (event.pageX - original_mouse_x))
                setPositionY(original_y + (event.pageY - original_mouse_y) < 40 ? 40 : original_y + (event.pageY - original_mouse_y))
            }
        } else if (action === 'resize') {
            if (target.classList.contains('left-width')) {
                document.onmousemove = (event) => {
                    const width = original_width - (event.pageX - original_mouse_x)
                    //console.log(width)
                    if (width > minWindowSizeW && width < document.documentElement.clientWidth) {
                        setIsOnDrag(true)
                        setWindowSizeW(width)
                        setPositionX(original_x + (event.pageX - original_mouse_x))
                    }
                }
            } else if (target.classList.contains('right-width')) {
                document.onmousemove = (event) => {
                    const width = original_width + (event.pageX - original_mouse_x)
                    if (width > minWindowSizeW && width < document.documentElement.clientWidth) {
                        setIsOnDrag(true)
                        setWindowSizeW(width)
                    }
                }
            } else if (target.classList.contains('top-height')) {
                document.onmousemove = (event) => {
                    const height = original_height - (event.pageY - original_mouse_y)
                    if (height > minWindowSizeH && height < document.documentElement.clientHeight - 40) {
                        setIsOnDrag(true)
                        setWindowSizeH(height)
                        setPositionY(original_y + (event.pageY - original_mouse_y) < 40 ? 40 : original_y + (event.pageY - original_mouse_y))
                    }
                }
            } else if (target.classList.contains('bottom-height')) {
                document.onmousemove = (event) => {
                    const height = original_height + (event.pageY - original_mouse_y)
                    if (height > minWindowSizeH && height < document.documentElement.clientHeight - 40) {
                        setIsOnDrag(true)
                        setWindowSizeH(height)
                    }
                }
            } else if (target.classList.contains('top-left')) {
                document.onmousemove = (event) => {
                    const width = original_width - (event.pageX - original_mouse_x)
                    const height = original_height - (event.pageY - original_mouse_y)
                    if (width > minWindowSizeW && width < document.documentElement.clientWidth) {
                        setIsOnDrag(true)
                        setWindowSizeW(width)
                        setPositionX(original_x + (event.pageX - original_mouse_x))
                    }
                    if (height > minWindowSizeH && height < document.documentElement.clientHeight - 40) {
                        setIsOnDrag(true)
                        setWindowSizeH(height)
                        setPositionY(original_y + (event.pageY - original_mouse_y) < 40 ? 40 : original_y + (event.pageY - original_mouse_y))
                    }
                }
            } else if (target.classList.contains('top-right')) {
                document.onmousemove = (event) => {
                    const width = original_width + (event.pageX - original_mouse_x)
                    const height = original_height - (event.pageY - original_mouse_y)
                    if (width > minWindowSizeW && width < document.documentElement.clientWidth) {
                        setIsOnDrag(true)
                        setWindowSizeW(width)
                    }
                    if (height > minWindowSizeH && height < document.documentElement.clientHeight - 40) {
                        setIsOnDrag(true)
                        setWindowSizeH(height)
                        setPositionY(original_y + (event.pageY - original_mouse_y) < 40 ? 40 : original_y + (event.pageY - original_mouse_y))
                    }
                }
            } else if (target.classList.contains('bottom-left')) {
                document.onmousemove = (event) => {
                    const height = original_height + (event.pageY - original_mouse_y)
                    const width = original_width - (event.pageX - original_mouse_x)
                    if (height > minWindowSizeH && height < document.documentElement.clientHeight - 40) {
                        setIsOnDrag(true)
                        setWindowSizeH(height)
                    }
                    if (width > minWindowSizeW && width < document.documentElement.clientWidth) {
                        setIsOnDrag(true)
                        setWindowSizeW(width)
                        setPositionX(original_x + (event.pageX - original_mouse_x))
                    }
                }
            } else if (target.classList.contains('bottom-right')) {
                document.onmousemove = (event) => {
                    const height = original_height + (event.pageY - original_mouse_y);
                    const width = original_width + (event.pageX - original_mouse_x);
                    if (width > minWindowSizeW && width < document.documentElement.clientWidth) {
                        setIsOnDrag(true)
                        setWindowSizeW(event.pageX - original_x)
                    }
                    if (height > minWindowSizeH && height < document.documentElement.clientHeight - 40) {
                        setIsOnDrag(true)
                        setWindowSizeH(event.pageY - original_y)
                    }
                }
            }
        }

    }

    window.onmouseup = (e) => {
        var desktopElement = document.getElementById('desktop');
        if (desktopElement) { desktopElement.style.cursor = 'auto'; }
        window.onmousemove = null;
        document.onmousemove = null;
        setTilingVisual(false)
        setIsOnDrag(false)
        rePositionWindow(e);
    }


    return (
        <>
            <div ref={windowRef} id={'taskWindow_' + props.task.taskID} className={'window' + (props.task.state === 'killing' ? ' killing' : ' alive')}
                style={
                    {
                        boxSizing: 'border-box',
                        overflow: 'hidden',
                        display: 'show',
                        width: windowSizeW,
                        height: windowSizeH,
                        position: 'absolute',
                        zIndex: props.task.zindex,
                        left: positionX,
                        top: positionY,
                        padding: 2,
                        borderRadius: 3,
                        transition: 'all ' + (isOnDrag ? '0.0' : '0.2') + 's',
                        ...(props.task.state === 'focus' ? specialWindowStyle.focusStyle.inFocus : specialWindowStyle.focusStyle.outFoucs),
                        ...(tiling === 'F' ? specialWindowStyle.position.fullWin : null),
                        ...(tiling === 'L' ? specialWindowStyle.position.leftTiling : null),
                        ...(tiling === 'R' ? specialWindowStyle.position.rightTiling : null),
                        ...(onSmallScreen ? specialWindowStyle.position.fullWin : null),
                        ...((props.task.state === 'minimized' && props.task.spotlighted) ?
                            specialWindowStyle.focusStyle.spotlighted : 
                            (props.task.state === 'minimized') ?
                                specialWindowStyle.position.hiddenWin : 
                                (props.task.spotlighted ?
                                    specialWindowStyle.focusStyle.spotlighted : null))
                    } as React.CSSProperties
                }
            >
                <div className={'windowInnerFrame'} onMouseDown={() => desktopControll.focusTask(props.task.taskID)}>
                    <div className={'windowHeader windowHeaderElement'} onDoubleClick={() => toggleFullScreen()} onMouseDown={(e) => { onMouseDown(e, 'dragMove'); }} >
                        <div>
                            <img style={{ height: 25 }} alt={props.task.app.config.showName} src={props.task.app.config.icon}></img>
                        </div>
                        <div className={'windowTitleText'}>
                            <span title={props.task.app.config.showName + (props.task.taskTitle ? ' : ' + props.task.taskTitle : '')}>
                              {props.task.app.config.showName}{props.task.taskTitle && ' : ' + props.task.taskTitle}
                            </span>
                        </div>
                        <div className={'windowButtons'} onDoubleClick={(e) => { e.stopPropagation(); }} onMouseDown={(e) => { e.stopPropagation(); }}>
                            <FontAwesomeIcon onClick={(e) => setMinisized()} style={{ width: 22, paddingTop: 3, color: 'white' }} size="lg" icon={faChevronCircleUp} />
                            {
                                onSmallScreen ? null : (
                                    <FontAwesomeIcon onClick={(e) => toggleFullScreen()} style={{ width: 22, paddingTop: 3, color: 'white' }} size="lg" icon={(tiling ? faStopCircle : faPlusCircle)} />
                                )
                            }
                            {props.task.closable && (
                              <FontAwesomeIcon style={{ width: 22, paddingTop: 3, color: 'white' }} size="lg" icon={faTimesCircle} onClick={() => { desktopControll.killTask(props.task.taskID) }} />
                            )}
                        </div>
                    </div>
                    <div className={'windowBody'}>
                        <div className={'AppSafeWrapper'}>
                            <AppBody taskInitParms={props.task.taskInitParms} taskID={props.task.taskID} />
                        </div>
                    </div>
                    {
                        (!tiling && !onSmallScreen) &&
                        <>
                            <div className='resizer left-width' onMouseDown={(e) => onMouseDown(e, 'resize')} ></div>
                            <div className='resizer right-width' onMouseDown={(e) => onMouseDown(e, 'resize')} ></div>
                            <div className='resizer top-height' onMouseDown={(e) => onMouseDown(e, 'resize')} ></div>
                            <div className='resizer bottom-height' onMouseDown={(e) => onMouseDown(e, 'resize')} ></div>
                            <div className='resizer top-left' onMouseDown={(e) => onMouseDown(e, 'resize')} ></div>
                            <div className='resizer top-right' onMouseDown={(e) => onMouseDown(e, 'resize')} ></div>
                            <div className='resizer bottom-left' onMouseDown={(e) => onMouseDown(e, 'resize')} ></div>
                            <div className='resizer bottom-right' onMouseDown={(e) => onMouseDown(e, 'resize')} ></div>
                        </>
                    }
                </div>
            </div>
            <div className={'tiling ' + tilingVisual}></div>
            <div style={{ zIndex: specialWindowStyle.focusStyle.spotlighted.zIndex - 1 }} className={'forceSummonBackFlim ' + (props.task.spotlighted ? ' active' : '')}></div>
        </>
    )
}

const specialWindowStyle = {
    focusStyle: {
        inFocus: {
            backgroundColor: 'rgb(64 64 64 / 95%)',
            boxShadow: '0px 2px 10px 0px rgba(0,0,0,0.53)'
        },
        outFoucs: {
            backgroundColor: 'rgb(89 89 89 / 80%)',
            backdropFilter: 'blur(4px)',
            boxShadow: '0px 2px 10px 0px rgba(0,0,0,0.23)'
        },
        spotlighted: {
            zIndex: 80,
            boxShadow: 'rgb(185 185 185 / 20%) 0px 2px 10px 10px',
        }
    },
    position: {
        fullWin: {
            width: '100%',
            height: 'calc(100dvh - 40px)',
            left: 0,
            top: 40,
        },
        leftTiling: {
            width: '50%',
            height: 'calc(100vh - 40px)',
            left: 0,
            top: 40,
        },
        rightTiling: {
            width: '50%',
            height: 'calc(100vh - 40px)',
            right: 0,
            left: 'unset',
            top: 40,
        },
        hiddenWin: {
            top: -50,
            left: 50,
            transform: 'scale(0)',
            transformOrigin: 'top left'
        } as React.CSSProperties,

    }
}
